import {
  baseDataRegionHeaderItem,
  baseDataPriceDetailItem,
  baseDataCityListRegionHeaderItem,
  parseCityRegionHeaderPriceTable, createRegionHeaderPriceTable, baseDataPriceDetailPriceItem
} from "./productQuotation";
import {mapFromArrayToObject} from "../../../assets/js/utils";
import {rulesNotEmpty} from "../../../assets/js/formRules";
import {debounce, isArray, isObject, throttle} from "my-tools-kit";
import {filterUnselectedList} from "@/components/QuotationManagement/components-productQuotation/filterUnselectedList/utils";
import {
  getApiChannelCodeList,
  requestCanGetApiChannelCode
} from "@/components/QuotationManagement/components-productQuotation/selectApiChannelCode/utils";
import axiosMain from "@/axios";
import store from "@/store";

let regionTypeArray = [
  {label:'邮编',value:1},
  {label:'国家',value:2},
  {label:'城市',value:3},
  {label:'仓库编码',value:4},
  { label: '邮编分区', value: 5 },
];
let timeTypeArray = [
  {label:'工作日',value:1},
  {label:'自然日',value:2},
];

/**
 * 校验城市维度区间列表
 * @param list
 * @param options  {{isSegment?:boolean,isSupportMultiChannel?:boolean,type?:string,[key:any]:any,isConvertOnPartition:boolean}}
 * @returns {string[]|boolean}
 */
export function checkCityRegionList(list = [],options){
  let {
    isSegment,// 是否是分段报价
    isSupportMultiChannel,// 是否多渠道
    type="head",// 分段类型：head-全包(头程) delivery-派送
    // 派送方式
    deliveryType
  } = options;
  let errorArray = [];
  let labelText = "城市区间列表 ";
  console.log(options.startCitySettingWarehouseParam);
  if(isArray(list) && list.length){
    list.every((item,index)=>{
      if(!(isArray(item.cityList) && item.cityList.length)){
        errorArray.push(`${labelText} 起运城市 不能为空`);
        return false;
      }
      let checkCityListResult = item.cityList.every((cityItem,cityIndex)=>{
        if(typeof cityItem.pickUpFlag !== "boolean"){
          errorArray.push(`${labelText} ${cityItem.cityName}是否支持免费上门提货 不能为空`);
          return false;
        }
        // 9-18调整 未在该城市入驻共享仓隐藏送货到仓仓库
        if (!options.startCitySettingWarehouseParams[cityItem.id].platformShareWarehouseFlag){
          if(!cityItem.receiveWarehouseId){
            errorArray.push(`${labelText} ${cityItem.cityName}送货到仓 不能为空`);
            return false;
          }
        }
        return true;
      })
      if(!checkCityListResult) return false;

      if(["head","all"].includes(type)){
        if(![0,1].includes(item.isSupportMultiGoodsTypePrice)) errorArray.push("是否支持多产品分类报价 不能为空");
      }
      let result = checkRegionList(item.regionHeaderList,options);
      if(isArray(result)) {
        errorArray.push(`${labelText} 分区方案 ` + result[0]);
        return false;
      }
      return true;
    })
  }else{
    errorArray.push(`${labelText} 不能为空`);
  }
  return errorArray.length ? errorArray : true;
}
/**
 * 校验分区设置列表
 * @param list
 * @param options {{isSegment?:boolean,isSupportMultiChannel?:boolean,type?:string,[key:any]:any}}
 * @returns {*[]|boolean}
 */
export function checkRegionList(list = [],options){
  let errorArray = [];
  let {
    isSegment,// 是否是分段报价
    isSupportMultiChannel,// 是否多渠道
    type="head",// 分段类型：head-全包(头程) delivery-派送,
    // 派送方式
    deliveryType
  } = options;
  if(options.deliveryType === "ZT") return true
  if(isArray(list) && list.length){
    list.every((item,index)=>{
      let result = checkRegionItem(item,index,options);
      if(result instanceof Array) {
        result = result.map(text=>{
          if(item.regionName){
            text = `分区【${item.regionName}】${text}`;
          }else{
            text = `第${index+1}个分区 ${text}`;
          }
          return text;
        })
        errorArray.push(...result);
      }
      return true;
    });
  }else{
    errorArray.push("列表 不能为空");
  }

  return errorArray.length ? errorArray : true;
}
function checkRegionItem(item = {},index,options){
  let {
    isSegment,// 是否是分段报价
    isSupportMultiChannel,// 是否多渠道
    type="head",// 分段类型：head-全包(头程) delivery-派送
  } = options;
  let errorArray = [];

  if(!item.regionName) errorArray.push("分区名称 不能为空");
  if(!item.regionType) errorArray.push("分区类型 不能为空");
  if(!item.type) errorArray.push("分段类型 不能为空");
  if(!item.chargeType) errorArray.push("计费方式 不能为空");
  // if(!item.dispatchId) errorArray.push("关联派送区间id 不能为空");

  // if(!isSegment || type!=="delivery"){
    // if(!item.dismantlingCityId) errorArray.push("拆柜城市id 不能为空");
    // if(!item.dismantlingCityName) errorArray.push("拆柜城市名称 不能为空");
  // }

  if(isArray(item.regionDetailList) && item.regionDetailList.length){
    // if(isArray(item.regionDetailList) && item.regionDetailList.length){
    // let result = checkRegionDetailList(item.regionDetailList);
    // if(result instanceof Array) {
    //   errorArray.push(...result);
    // }
  }else{
    errorArray.push("分区信息列表 不能为空");
  }

  if(isArray(item.priceDetailList) && item.priceDetailList.length){
    let result = checkPriceDetailList(item.priceDetailList,{...options, chargeType: item.chargeType});
    if(result instanceof Array) {
      errorArray.push(...result.map(text=> `报价明细列表 ${text}`));
    }
  }else{
    errorArray.push("报价明细列表 不能为空");
  }

  // if(!isSegment && ["head","all"].includes(type)){
  //   let extractionAgingFrom = parseFloat(item.extractionAgingFrom);
  //   let extractionAgingTo = parseFloat(item.extractionAgingTo);
  //   if(!extractionAgingFrom) errorArray.push("提取时效(起) 不能 为空/为0");
  //   if(!extractionAgingTo) errorArray.push("提取时效(止) 不能 为空/为0");
  //   if(extractionAgingFrom && extractionAgingTo){
  //     if(extractionAgingFrom > extractionAgingTo) errorArray.push("提取时效(起) 不能大于 派送时效(止)");
  //   }
  //   if(!item.extractionAgingUnit) errorArray.push("提取时效单位 不能为空");
  // }
  //
  // let agingLabel = type === "delivery" ? "派送时效" : "整体时效";
  // let agingFrom = parseFloat(item.agingFrom);
  // let agingTo = parseFloat(item.agingTo);
  // if(!agingFrom) errorArray.push(`${agingLabel}(起) 不能 为空/为0`);
  // if(!agingTo) errorArray.push(`${agingLabel}(止) 不能 为空/为0`);
  // if(agingFrom && agingTo){
  //   if(agingFrom > agingTo) errorArray.push(`${agingLabel}(起) 不能大于 ${agingLabel}(止)`);
  // }
  // if(!item.agingUnit) errorArray.push(`${agingLabel}单位 不能为空`);


  return errorArray.length ? errorArray : true;
}


function checkPriceDetailList(list = [],options){
  let errorArray = [];
  let {
    isSegment,// 是否是分段报价
    isSupportMultiChannel,// 是否多渠道
    type="head",// 分段类型：head-全包(头程) delivery-派送
    chargeType,// 计费单位
    isConvertOnPartition=false,// 是否按最小分区设置转换系数
  } = options;

  list.every((item,index)=>{
    if(["head","all"].includes(type)){
      if(!(isArray(item.goodsTypeList) && item.goodsTypeList.length)) {
        errorArray.push(`第${index+1}个 可走货物类型 不能为空`);
        return false
      }
      if (isConvertOnPartition) {
        const ratio = chargeType === 'KG' ? item.volumeWeightRatio : item.weightVolumeRatio
        if (!ratio) {
          const ratioName = chargeType === 'KG' ? '体积重比率' : '重量转换'
          errorArray.push(`第${index+1}个 ${ratioName} 不能为空`)
          return false
        }
      }
    }
    if(typeof item.isNeedInquiry !== "boolean") {
      errorArray.push(`第${index+1}个 是否支持单询 不能为空`);
      return false
    }
    if(["delivery"].includes(type)){
      if(![1,2].includes(item.exemptionType)) {
        errorArray.push(`第${index+1}个 exemptionType 不能为空`);
        return false
      }
    }
    if(isSupportMultiChannel) {
      if(!item.channelCode) {
        errorArray.push(`第${index+1}个 专线api对接渠道代码 不能为空`);
        return false
      }
    }
    if(isArray(item.priceList) && item.priceList.length) {
      let result = checkRegionPriceList(item.priceList,Object.assign({
        exemptionType:item.exemptionType,
        isNeedInquiry:item.isNeedInquiry,
      },options));
      if(result instanceof Array) {
        errorArray.push(...result.map(text=> `第${index+1}个 价格明细列表 ${text}`));
        return false
      }
    }else{
      errorArray.push(`第${index+1}个 价格明细列表 不能为空`);
      return false
    }
    if(!isSegment && ["head","all"].includes(type)){
      let extractionAgingFrom = parseFloat(item.extractionAgingFrom);
      let extractionAgingTo = parseFloat(item.extractionAgingTo);
      if(!extractionAgingFrom) errorArray.push("提取时效(起) 不能 为空/为0");
      if(!extractionAgingTo) errorArray.push("提取时效(止) 不能 为空/为0");
      if(extractionAgingFrom && extractionAgingTo){
        if(extractionAgingFrom > extractionAgingTo) errorArray.push("提取时效(起) 不能大于 派送时效(止)");
      }
      if(!item.extractionAgingUnit) errorArray.push("提取时效单位 不能为空");
    }

    let agingLabel = type === "delivery" ? "派送时效" : "整体时效";
    let agingFrom = parseFloat(item.agingFrom);
    let agingTo = parseFloat(item.agingTo);
    if(!agingFrom) errorArray.push(`${agingLabel}(起) 不能 为空/为0`);
    if(!agingTo) errorArray.push(`${agingLabel}(止) 不能 为空/为0`);
    if(agingFrom && agingTo){
      if(agingFrom > agingTo) errorArray.push(`${agingLabel}(起) 不能大于 ${agingLabel}(止)`);
    }
    if(!item.agingUnit) errorArray.push(`${agingLabel}单位 不能为空`);

    // if(!item.remark) {
    //   errorArray.push(`第${index+1}个 备注 不能为空`);
    //   return false
    // }
    return true;
  });
  return errorArray.length ? errorArray : true;
}
/**
 * 校验 单个分区信息的 价格明细列表
 * @param list {[object]}
 * @param options {{exemptionType?:number,isNeedInquiry?:boolean,}}
 * @returns {*[]|boolean}
 */
function checkRegionPriceList(list = [],options){
  let errorArray = [];
  let {
    exemptionType,//免派类型，1：不免派(默认)；2：免派
    isNeedInquiry,//是否支持单询
    type, //分段类型
  } = options;
  list.every((item,index)=>{
    if(!item.chargeSectionDetailId) {
      errorArray.push(`第${index+1}个 分区区间id 不能为空`);
      return false
    }
    if(options.isNeedInquiry || options.exemptionType === 2){ // 单询 或 免派
      if([undefined,"",null].includes(item.price)){
        errorArray.push(`第${index+1}个 区间单价 不能为空`);
        return false
      }
    }else if([0,"0"].includes(item.price) || /^\s*0[0\s]*$/g.test(`${item.price}`)) {
      if (type === 'head') {
        if (index + 1 === list.length) {
          errorArray.push(`第${index + 1}个 区间单价 不能为0`);
          return false
        }
      } else {
        if(index !== 0){
          errorArray.push(`第${index+1}个 区间单价 不能为0`);
          return false
        }
      }
    }else if(!item.price) {
      errorArray.push(`第${index+1}个 区间单价 不能为空`);
      return false
    }
    // if(!item.sectionStartNum) {
    //   errorArray.push(`第${index+1}个 区间开始值 不能为空`);
    //   return false
    // }
    // if(!item.sectionEndNum) {
    //   errorArray.push(`第${index+1}个 区间结束值 不能为空`);
    //   return false
    // }
    return true;
  });
  return errorArray.length ? errorArray : true;
}

function checkRegionDetailList(list = []){
  let errorArray = [];
  list.every((item,index)=>{
    if(!item.namec) {
      errorArray.push("分区目的地名称 不能为空");
      return false
    }
    if(!item.warehouseId) {
      errorArray.push("分区目的地id 不能为空");
      return false
    }
    return true;
  });
  return errorArray.length ? errorArray : true;
}


export let mixinsFreightPrice = {
  data() {
    let rulesExtractionAgingFrom= (rule, value, callback)=>{
      let start = value;
      if([0,'0'].includes(start)) return callback(new Error('最短提取时效 不能 = 0'));
      start = parseFloat(start);
      if(start<0) return callback(new Error('最短提取时效 不能 < 0'));
      let end = this.editFormTime.extractionAgingTo;
      if([0,'0'].includes(end)) return callback(new Error('最长提取时效 不能 = 0'));
      end = parseFloat(end);
      if(end<0) return callback(new Error('最长提取时效 不能 < 0'));
      if(start > end) return callback(new Error('最短提取时效 > 最长提取时效'))
      return callback();
    };
    let rulesAgingFrom = (rule, value, callback)=>{
      let start = value;
      if([0,'0'].includes(start)) return callback(new Error('最短派送时效 不能 = 0'));
      start = parseFloat(start);
      if(start<0) return callback(new Error('最短派送时效 不能 < 0'));
      let end = this.editFormTime.agingTo;
      if([0,'0'].includes(end)) return callback(new Error('最长派送时效 不能 = 0'));
      end = parseFloat(end);
      if(end<0) return callback(new Error('最长派送时效 不能 < 0'));
      if(start > end) return callback(new Error('最短派送时效 > 最长派送时效'))
      return callback();
    };
    return {
      // 币种
      currencyList:[],
      /* 分区报价类型 */
      regionQuotationTypeCurrent:"head",
      regionQuotationTypeList:[
        {label:"头程",value:"head"},
        {label:"派送",value:"delivery"},
      ],
      regionHeaderList:[],// 全包(头程) 分区价格信息列表 baseDataRegionHeaderItem()
      deliveryRegionHeaderList:[],// 派送分区价格信息列表 baseDataRegionHeaderItem()
      // 币种（全包/分段头程）
      currency:"",
      // 币种（分段派送）
      currencyDelivery:"",
      // 是否按分区设置计费转换系数
      isConvertOnPartition: false,

      cityRegionHeaderList:[],// 起运城市维度的 全包(头程) 分区价格信息列表 baseDataCityListRegionHeaderItem()
      cityRegionHeaderCurrent:"",
      cityRegionHeaderPriceTable:[],// 将 cityRegionHeaderList 对应的经过处理适合table展示的数据结构 详见 baseDataCityRegionHeaderPriceTableItem() 和 baseDataPriceDetailItem()
      deliveryCityRegionHeaderPriceTable:[],//派送的
      /* 选择框 数据 */
      // 分区类型
      regionTypeList:regionTypeArray,
      regionTypeListMapObject:mapFromArrayToObject(regionTypeArray),
      /*分区总列表*/
      subareaList:[],
      subareaListCity:[],//城市列表，供头程使用
      subareaListMapObject:[],
      /* 拆柜城市 */
      cgCityList:[
        {id:1,namec:"测试"},
        {id:2,namec:"牛B"},
      ],
      /*弹窗：设置时间*/
      timeTypeList:timeTypeArray,
      visibleSetTime:false,
      editFormTimeIndex:0,
      editFormTime:{},
      formRulesFreightPrice: {
        extractionAgingFrom:[
          rulesNotEmpty(),
          {trigger: 'blur', validator:rulesExtractionAgingFrom}
        ],
        agingFrom:[
          rulesNotEmpty(),
          {trigger: 'blur', validator:rulesAgingFrom}
        ],
        price:[
          rulesNotEmpty(),
          {trigger: 'blur', validator:(rule, value, callback)=>{
              let start = value;
              if([0,'0'].includes(start)) return callback(new Error('不能=0'));
              start = parseFloat(start);
              if(start<0) return callback(new Error('不能<0'));
              return callback();
            }
          }
        ]
      },
      // 供应商编辑里是否勾选了是否可获取到专线API对接渠道代码
      canGetChannelCode:null,
      // 专线api对接渠道代码列表
      apiChannelCodeList:[],
      // 专线api对接渠道代码列表 是否正在请求中
      apiChannelCodeListLoading:false,
      // 专线api对接渠道代码列表 请求间隔
      apiChannelCodeRequestSpace:0,
      apiChannelCodeTimeTarget:null,
      // 专线api对接渠道代码列表 获取状态  0-未请求  1-请求成功 2-请求失败
      apiChannelCodeListGetStatus:0,
      // 起运城市的收货仓库设置前置数据
      startCitySettingWarehouseParams:{
        // "cityId123":{
        //   platformShareWarehouseFlag: true,
        //   warehouseList:[],
        // }
      },
      startCitySettingWarehouseParamsLoading:{

      },

    }
  },
  created(){

  },
  methods:{
    filterUnselectedList,
    /**
     * 判断是否需要 刷新 分区类型信息列表
     * @param logisticsProductId  {number|string} 物流产品id
     * @param regionType  {number|string} 分区类型
     * @returns {boolean}
     */
    judgeNeedRefreshRegionTypeDetails(logisticsProductId,regionType){
      // // this.setRegionTypeDetails();
      // this.subareaList = [];
      // this.subareaListCity = [];
      // let logisticsProductId = this.editFormData.logisticsProductId;
      // let regionType = this.editFormData.regionType;
      if(!logisticsProductId) {
        this.$message.error('缺少默认【物流产品id】，无法获取【分区类型信息列表】');
        return false;
      }
      if(!regionType) {
        this.$message.error('缺少默认【分区类型】，无法获取【分区类型信息列表】');
        return false;
      }
      return true;
    },
    /**
     * 获取 分区类型信息列表
     */
    getRegionTypeDetails(id=this.editFormData.logisticsProductId,endCountryId=this.editFormData.podId,type=this.editFormData.regionType,isSegment=false) {
      if(!id) return false;
      if(!type) return false;
      this.loading = true;
      let url = "/api/carrier/productPriceNew/getCarrierLogisticsProductRegionInfoById";
      let data = {
        id,//
        podId:endCountryId,  // 目的国id regionType为邮编时需要
        regionType:type,// 分区类型 1：邮编 2：国家 3：城市 4：仓库编码
      };
      return this.axios.post(url,data,{
        // headers:{"Content-Type":"application/json",}
      })
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loading = false;
          let list = res.datas || [];
          if(!isSegment) this.setRegionTypeDetails(list);
          else this.subareaListCity = list;
        })
        .catch((res) => {
          this.loading = false;
          this.setRegionTypeDetails();
          this.subareaListCity = [];
        });
    },
    setRegionTypeDetails(list = []){
      if(list instanceof Array && list.length){
        this.subareaList = list;
        this.subareaListMapObject = mapFromArrayToObject(list,{label: 'namec', value: 'warehouseId'});
      }else{
        this.subareaList = [];
        this.subareaListMapObject = {};
      }
    },
    /**
     * 增加分区
     */
    plusSubareaItem(type){
      if(type === "delivery"){
        this.deliveryRegionHeaderList.push(this.newRegionItem())
      }else if(type === "head"){
        this.regionHeaderList.push(this.newRegionItem())
      }else{
        this.tableData.push(this.newRegionItem());
      }
    },
    newRegionItem(){
      let data = baseDataRegionHeaderItem();
      data.priceDetailList = this.tableHeadList.map(res=>{
        return Object.assign(baseDataPriceDetailItem(),{
          chargeSectionDetailId:res.chargeSectionDetailId,
          sectionStartNum:res.start,
          sectionEndNum:res.end,
          titleText:`${res.start}-${res.end}${this.logisticsProductsDetails.chargeType}`,
          chargeType:this.logisticsProductsDetails.chargeType,
        })
      });
      return data;
    },
    /**
     * 移除
     */
    removeSubareaItem(index=1,type){
      if(type === "delivery"){
        this.deliveryRegionHeaderList.splice(index,1);
      }else if(type === "head"){
        this.regionHeaderList.splice(index,1);
      }else{
        this.tableData.splice(index,1);
      }

    },
    /**
     * 提交前检查报价数据
     */
    checkRegionListData(){
      let details = this.logisticsProductsDetails || {};
      let result;
      let options = {
        // 是否是分段报价
        isSegment:details.isSegment,
        // 是否是分段报价
        isSupportMultiChannel:this.editFormData.isSupportMultiChannel,
        // 分段类型：head-全包(头程) delivery-派送
        type:"head",
        // 派送方式
        deliveryType: this.editFormData.deliveryType
      };
      if(!this.editFormData.effectiveStartTime){
        this.$message.error("起始生效时间 不能为空");
        return false;
      }
      if(!this.editFormData.effectiveEndTime){
        this.$message.error("截止生效时间 不能为空");
        return false;
      }
      if(!(isArray(this.editFormData.polCityList) && this.editFormData.polCityList.length)){
        this.$message.error("基础信息 收货城市 不能为空");
        return false;
      }
      if(details.isSegment){
        if(!this.currency){
          this.$message.error("头程币种不能为空");
          return false;
        }
        // result = checkRegionList(this.regionHeaderList,options,);
        result = checkCityRegionList(this.cityRegionHeaderList,options,);
        if(isArray(result)) {
          this.$message.error("分区设置-头程报价 " + result[0]);
          return false;
        }
        if(this.editFormData.deliveryType !== "ZT"){
          if(!this.currencyDelivery){
            this.$message.error("派送币种不能为空");
            return false;
          }
          result = checkRegionList(this.deliveryRegionHeaderList,Object.assign({},options,{type:"delivery",}),);
          if(isArray(result)) {
            this.$message.error("分区设置-派送报价 " + result[0]);
            return false;
          }
        }
      }else{
        if(!this.currency){
          this.$message.error("币种不能为空");
          return false;
        }
        // result = checkRegionList(this.regionHeaderList,options,);
        // if(isArray(result)) {
        //   this.$message.error("分区设置 " + result[0]);
        //   return false;
        // }
        result = checkCityRegionList(this.cityRegionHeaderList,options,);
        if(isArray(result)) {
          this.$message.error("分区设置 " + result[0]);
          return false;
        }
      }
      return true;
    },
    /**
     * 获取币种列表
     */
    getAllCurrencyList(){
      let url = "/filedata/findCurrencyAll";
      this.axios.get(url)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.loading = false;
          let list = res.datas || [];
          list = list.map(item=>{
            return {
              label:item,
              value:item,
            }
          });
          this.currencyList = list;
        })
        .catch(res => {
          this.currencyList = [];
        })
    },
    /**
     * 刷新头程区间用来展示的table数据
     */
    refreshCityRegionHeaderPriceTable(type,list) {
      console.log('refreshCityRegionHeaderPriceTable', list)
      if(["delivery"].includes(type)){
        this.deliveryCityRegionHeaderPriceTable = createRegionHeaderPriceTable(list);
      }
      //else if(["all","head"].includes(type)){
      else {
        this.cityRegionHeaderPriceTable = parseCityRegionHeaderPriceTable(list);
      }
    },
    /**
     * 修改单个区间的区间名称时
     */
    refreshSingleRowRegionName(val,regionItem,type=""){
      let list = []
      if(["delivery"].includes(type)){
        list = this.deliveryCityRegionHeaderPriceTable;
      }
      //else if(["all","head"].includes(type)){
      else {
        list = this.cityRegionHeaderPriceTable
      }
      list = list.filter(item=>item._idRegion === regionItem._id);
      list.forEach(item=>item.regionName = val);
    },
    /**
     * 改变 单个 城市维度区间tabItem的起运城市时
     * @param val
     */
    refreshSingleCityRegionSelectCityValue(val = [],cityRegionItem={}){
      let list = this.cityRegionHeaderPriceTable.filter(item=>item._idCityRegion === cityRegionItem._id);
      let cityNameText = val.map(item=>item.cityName).join(",");
      list.forEach(item=>item.cityNameText = cityNameText);
    },
    /**
     * 修改 单个报价行的时效
     */
    refreshSinglePriceRowAging(value,priceDetailsItem,type=""){
      // let keys = Object.keys(value);
      // let regionItem;
      // let tableList = [];
      // if(["delivery"].includes(type)){
      //   tableList = this.deliveryCityRegionHeaderPriceTable;
      //   regionItem = this.deliveryRegionHeaderList.find(item=>item._id===priceDetailsItem._idRegion);
      // }else{
      //   tableList = this.cityRegionHeaderPriceTable;
      //   let cityRegionItem = this.cityRegionHeaderList.find(item=>item._id===priceDetailsItem._idCityRegion);
      //   if(cityRegionItem) regionItem = cityRegionItem.regionHeaderList.find(item=>item._id===priceDetailsItem._idRegion);
      // }
      //
      // if(regionItem) keys.forEach(key=> regionItem[key] = value[key]);
      // let needEditList = tableList.filter(item=>item._idRegion === priceDetailsItem._idRegion);
      // needEditList.forEach(target=>{
      //   keys.forEach(key=> target[key] = value[key]);
      // })
    },
    /**
     * 修改 是否支持多产品分类报价
     */
    changeSupportMultiGoodsTypePrice(value,cityRegionItem={},type="head"){
      if(!value){
        cityRegionItem.regionHeaderList.forEach(regionItem=>{
          // 只留一条
          if(regionItem.priceDetailList.length>1) regionItem.priceDetailList.splice(1,regionItem.priceDetailList.length-1);
          if(regionItem.priceDetailList.length>=1){
            let first = regionItem.priceDetailList[0];
            // 不是多国家分区才填充所有的货物类型,否则要根据分区的国家过滤当前分区国家支持的货物类型
            if (regionItem.regionType !== 6) {
              first.goodsTypeList = this.editFormData.goodsTypeList.map(item => item);
            }
          }
        })
        this.refreshCityRegionHeaderPriceTable(type,this.cityRegionHeaderList);
      }
    },
    /**
     * 改变 是否多渠道
     */
    changeMultipleChannels(){
      this.changeSingleChannelCode(this.editFormData.channelCode);
    },
    /**
     * 编辑 非多专线api对接渠道代码输入框
     * @param val
     */
    changeSingleChannelCode(val){
      // 全包/头程
      this.cityRegionHeaderList.forEach(cityRegionItem=>{
        cityRegionItem.regionHeaderList.forEach(regionItem=>{
          regionItem.priceDetailList.forEach(item=>{
            item.channelCode = val;
          });
        });
      });
      this.cityRegionHeaderPriceTable.forEach(item=>{
        item.channelCode = val;
      });

      if(this.logisticsProductsDetails.isSegment){
        // 派送
        this.deliveryRegionHeaderList.forEach(regionItem=>{
          regionItem.priceDetailList.forEach(item=>{
            item.channelCode = val;
          });
        });
        this.deliveryCityRegionHeaderPriceTable.forEach(item=>{
          item.channelCode = val;
        });
      }
    },
    /**
     * 获取拆柜城市列表
     * @param countryId
     */
    getCgCityList(countryId="") {
      let url = `/api/filedata/findCarrierOverseaWarehouseCityList`;
      let data = {
        countryId,
      };
      this.axios.get(url,{params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.cgCityList = res.datas || [];
        })
        .catch(res=>{
          this.cgCityList = [];
        })
    },
    /**
     * 获取 供应商编辑里是否勾选了是否可获取到专线API对接渠道代码 标记
     * @returns {Promise<{code: number, data: null}|*>}
     */
    getCanGetApiChannelCode(){
      if(typeof this.canGetChannelCode === "boolean") return Promise.resolve({
        code:1,
        data:this.canGetChannelCode,
      });
      return requestCanGetApiChannelCode()
        .then(res=>{
          this.canGetChannelCode = res.data
          return Promise.resolve({
            code:1,
            data:this.canGetChannelCode,
          });
        })
        .catch(res=>{
          this.canGetChannelCode = false;
          return Promise.resolve({
            code:1,
            data:this.canGetChannelCode,
          });
        })
    },
    /**
     * 并请求专线api对接渠道代码列表
     * @returns {boolean}
     */
     startGetChannelCodeList(){
      if(this.canGetChannelCode === false) return false;
      if(this.apiChannelCodeListLoading) return false;
      if(this.apiChannelCodeListGetStatus !== 0) return false;
      this.apiChannelCodeListLoading = true;
      this.apiChannelCodeRequestSpace = 60;
      this.apiChannelCodeTimeTarget = setInterval(()=>{
        this.apiChannelCodeRequestSpace = this.apiChannelCodeRequestSpace - 1;
        console.log(this.apiChannelCodeRequestSpace);
        if(this.apiChannelCodeRequestSpace <= 0) {
          this.apiChannelCodeRequestSpace = 0;
          clearInterval(this.apiChannelCodeTimeTarget);
        }
      },1000);

      // setTimeout(()=>{
      // },10 * 1000)
      getApiChannelCodeList(true)
        .then(res=>{
          console.log("startGetChannelCodeList() then",res);
          this.apiChannelCodeRequestSpace = 0;
          clearInterval(this.apiChannelCodeTimeTarget);
          this.apiChannelCodeListLoading = false;
          this.apiChannelCodeListGetStatus = 1;
          let list = res.data && res.data.services || [];
          this.apiChannelCodeList = list;
        })
        .catch(res=>{
          console.error(res);
          this.apiChannelCodeRequestSpace = 0;
          clearInterval(this.apiChannelCodeTimeTarget);
          this.apiChannelCodeListLoading = false;
          this.apiChannelCodeListGetStatus = 2;
          this.apiChannelCodeList = [];
        })

    },
  },
  computed:{
    /**
     * 已经被选择的起运城市列表
     * */
    alreadySelectStartCityList(){
      let alreadySelect = [];
      this.cityRegionHeaderList.forEach(res=>{
        let cityList = res.cityList || [];
        alreadySelect.push(...cityList);
      });
      return alreadySelect;
    },
  },
  watch:{

  }
};

/**
 * 根据已选择的收货城市列表和保存的对应收货仓库信息，判断需要获取哪些对应收货仓库信息
 * @param ids {string[]}  已选择的收货城市ids
 * @param saveTarget {object} 存储对象
 * @param loadingTarget {object} 请求状态集合
 * @return {boolean}
 */
export function checkGetStartCityWarehouseList(ids = [],saveTarget = {},loadingTarget){
  if(!isArray(ids)) return false;
  if(!isObject(saveTarget)) return false;
  let noIds = ids.filter(id => {
    return !saveTarget[id] && !loadingTarget[id]
  });
  if(noIds.length) {
    noIds.forEach(id=> loadingTarget[id] = true );
    getStartCityWarehouseList(noIds)
      .then(res=>{
        noIds.forEach(id=> loadingTarget[id] = false );
        let list = res.datas||[];
        list.forEach(item=>{
          if(!isArray(item.warehouseList)) item.warehouseList = []
          saveTarget[item.cityId] = item;
        })
      })
      .catch(res=>{
        noIds.forEach(id=> loadingTarget[id] = false );
      });
  }
}

/**
 * 根据城市id获取供应商对应收货仓库信息
 * @param cityId  {string|string[]}  起运城市id
 * @return {Promise<AxiosResponse<any>>}
 */
export function getStartCityWarehouseList(cityId=""){
  let url = `/api/carrier/productPriceNew/getCarrierCityWarehouseByCityIds`;
  // 当前服务商id
  let carrierId = store.state.Authorization.customerid;
  let data = {
    "carrierId": carrierId,
    "cityIds": isArray(cityId) ? cityId : [cityId],
  };
  return axiosMain.post(url,data)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
}

/**
 * 根据城市id 插入 供应商对应的收货仓库信息
 */
export function insertStartCityMatchWarehouseInfo(cityList,startCitySettingWarehouseParams){
  cityList.forEach(item=>{
    let info = startCitySettingWarehouseParams[item.id];
    if(isObject(info) && info.cityId){
      item.platformShareWarehouseFlag = info.platformShareWarehouseFlag;
      if(item.receiveWarehouseId && isArray(info.warehouseList)){
        let warehouse = info.warehouseList.find(warehouse=>warehouse.id === item.receiveWarehouseId);
        item.receiveWarehouseName = warehouse ? warehouse.namec : '';
        item.receiveWarehouseCode = warehouse ? warehouse.code : '';
      }
    }
  })
}

/**
 * 从城市维度的区间列表中的cityList匹配对应城市id的属性pickUpFlag、receiveWarehouseId的值（该城市是否支持上门取件）
 * @param cityList
 * @param cityListRegionHeader
 */
export function startCityMatchRegionInnerCityInfo(cityList = [],cityListRegionHeader = []){
  let allCityList = []
  cityListRegionHeader.forEach(item=> allCityList.push(...item.cityList));
  cityList.forEach(item=>{
    let innerCity = allCityList.find(city => city.id === item.id);
    if(innerCity) {
      if(item.pickUpFlag !== innerCity.pickUpFlag) item.pickUpFlag = innerCity.pickUpFlag
      if(item.receiveWarehouseId !== innerCity.receiveWarehouseId) item.receiveWarehouseId = innerCity.receiveWarehouseId
    }
  })
}
/**
 * 拼接提交参数：全包/头程分区价格信息列表（通过解析城市区间维度列表数据）
 * @param cityRegionHeaderList
 * @param options {{currency?:string,regionType?:number,isSegment?:boolean,goodsTypeList?:array,supportRenewal?:boolean,isOnlySupportRenewal?:boolean,isCollectRenewalFee?:boolean,startCitySettingWarehouseParams?:object[]}}
 * @returns {*[]}
 */
export function getSubmitRegionHeaderList(cityRegionHeaderList = [],options={}){
  let resultArr = [];
  if(!(isArray(cityRegionHeaderList)&& cityRegionHeaderList.length)) return resultArr;
  cityRegionHeaderList.forEach((cityRegionItem,cityRegionIndex)=>{
    // 起运城市
    // let cityList = JSON.parse(JSON.stringify(cityRegionItem.cityList||[]));
    // 起运城市(含sort值)
    let cityList = listAddedSortIndex(cityRegionItem.cityList);
    insertStartCityMatchWarehouseInfo(cityList,options.startCitySettingWarehouseParams);

    cityRegionItem.regionHeaderList.forEach((regionItem,regionIndex)=>{
      regionItem = JSON.parse(JSON.stringify(regionItem));
      // 分区类型 1：邮编 2：国家 3：城市 4：仓库编码
      // 分段时，头程的分区类型强制为 3-城市
      regionItem.regionType = options.isSegment ? 3 : options.regionType;
      // 是多国家报价将countryId设置为warehouseId
      if (regionItem.regionType === 6) {
        regionItem.countryId = regionItem.regionDetailList[0].warehouseId
      }
      // 币种
      regionItem.currency = options.currency;
      //是否支持多产品分类报价 0>false 1>true
      regionItem.isSupportMultiGoodsTypePrice = cityRegionItem.isSupportMultiGoodsTypePrice === 1;
      // 保存 起运城市列表
      regionItem.cityList = cityList;
      // 是否支持首续重
      regionItem.supportRenewal = !!options.supportRenewal;
      //首重续重 是否支持多分段报价
      regionItem.isOnlySupportRenewal = !!options.isOnlySupportRenewal;
      //超出续重区间是否仍收取首重费
      regionItem.isCollectRenewalFee = !!options.isCollectRenewalFee;
      // copy的所有的可走货物类型列表（含sort值）
      let allGoodsTypeList = [];
      if(!cityRegionItem.isSupportMultiGoodsTypePrice) allGoodsTypeList = listAddedSortIndex(options.goodsTypeList);
      // 以货物类型为维度的具体分区列表
      regionItem.priceDetailList.forEach((item,index)=>{
        item.sort = index + 1;
        // 不是多国家分区才填充所有的货物类型,否则要根据分区的国家过滤当前分区国家支持的货物类型
        if (regionItem.regionType !== 6) {
          // 2023-10-11 需求4111支持删除货物类型操作
          item.goodsTypeList = listAddedSortIndex(item.goodsTypeList);
          /*if (cityRegionItem.isSupportMultiGoodsTypePrice) {
            // 当前项的 可走货物类型列表 重新填充排序值
            item.goodsTypeList = listAddedSortIndex(item.goodsTypeList);
          } else {
            // 当不支持多产品分类报价时，默认重新填充所有可走货物类型
            // item.goodsTypeList = isArray(options.goodsTypeList) ? options.goodsTypeList : [];
            item.goodsTypeList = allGoodsTypeList;
          }*/
        }
      })
      // 分区维度排序值
      regionItem.sort = resultArr.length + 1;

      // 将每项的货物类型列表中的体积重量比和重量体积比填充
      regionItem.priceDetailList.forEach(price => {
        price.goodsTypeList = price.goodsTypeList.map(good => {
          return { ...good, volumeWeightRatio: price.volumeWeightRatio, weightVolumeRatio: price.weightVolumeRatio }
        })
      })
      resultArr.push(regionItem);
    })
  });
  return resultArr;
}

/**
 * 给列表按照索引值添加sort
 * @param list
 * @returns {any[]|*[]}
 */
function listAddedSortIndex(list = []) {
  if(!isArray(list)) return [];
  return list.map((item,index)=>{
    return Object.assign({},item,{
      // 起运城市维度排序值
      sort: index + 1,
    });
  });
}

/**
 * 拼接提交参数：派送分区价格信息列表
 * @param deliveryRegionHeaderList
 * @param options
 * @returns {*[]}
 */
export function getSubmitDeliveryRegionHeaderList(deliveryRegionHeaderList = [],options={}){
  let resultArr = [];
  if(!(isArray(deliveryRegionHeaderList)&& deliveryRegionHeaderList.length)) return resultArr;
  deliveryRegionHeaderList.forEach((regionItem,regionIndex)=>{
    regionItem = JSON.parse(JSON.stringify(regionItem));
    // 分区类型 1：邮编 2：国家 3：城市 4：仓库编码
    // 分段时，全包的分区类型强制为 3-城市
    regionItem.regionType = options.regionType;
    // 币种
    regionItem.currency = options.currency;
    // 派送不需要 是否支持多产品分类报价 0>false 1>true
    regionItem.isSupportMultiGoodsTypePrice = false;
    // 派送不需要 起运城市列表
    regionItem.cityList = [];
    // 按车计费，卡车id
    if(!regionItem.containerId) regionItem.containerId = options.containerId||"";
    //是否支持首续重
    regionItem.supportRenewal = !!options.supportRenewal;
    //首重续重 是否支持多分段报价
    regionItem.isOnlySupportRenewal = !!options.isOnlySupportRenewal;
    //超出续重区间是否仍收取首重费
    regionItem.isCollectRenewalFee = !!options.isCollectRenewalFee;
    // 以货物类型为维度的具体分区列表
    regionItem.priceDetailList.forEach((item,index)=>{
      item.sort = index + 1;
      // 派送不需要可走货物类型
      item.goodsTypeList = [];
    })
    // 分区维度排序值
    regionItem.sort = resultArr.length + 1;
    resultArr.push(regionItem);
  })
  return resultArr;
}

/**
 * 创建 新增区间 的item数据
 * @param options
 */
export function createRegionHeaderItem(options={}){
  let goodsTypeList = [];
  if(!options.isSupportMultiGoodsTypePrice) goodsTypeList.push(...options.goodsTypeList);

  let priceList = options.tableHeadList.map(res=>{
    if(!(res instanceof Object)) res = {};
    return Object.assign(baseDataPriceDetailPriceItem(res.start, options.tableHeadList[0].supportRenewal, options.type),{
      chargeSectionDetailId:res.chargeSectionDetailId,// 分区区间id
      sectionStartNum:res.start,// 区间开始值
      sectionEndNum:res.end,// 区间结束值
    })
  });

  let priceDetailItem = Object.assign(baseDataPriceDetailItem(),{
    goodsTypeList,
    priceList,
    channelCode:options.channelCode||"",
  })

  let firstItem = options.tableHeadList[0]||{};

  let data = baseDataRegionHeaderItem();
  Object.assign(data,{
    regionType:options.regionType,//分区类型
    type:options.type || 1,//分段类型 1：全包(头程) 2:派送
    dispatchId:firstItem.dispatchId, //关联派送区间id
    chargeType:options.chargeType || firstItem.chargeType,//计费方式: CBM:体积 KG:重量
    priceDetailList:[priceDetailItem],
  })
  return data;
}

/**
 * 初始化编辑数据：将获取到的全包/头程分区列表 初始化为 城市分区维度的数据结构
 * @param regionHeaderList  {array}
 * @param disposeRegionItemCallback {function}
 * @returns {*[]}
 */
export function initEditDataCityRegionList(regionHeaderList=[],disposeRegionItemCallback = initEditDataRegionItem){
  let cityRegionList = [];
  regionHeaderList.forEach(regionItem=>{
    let isFirst = true;
    let cityList = regionItem.cityList||[];
    let cityRegionItem = findCityRegionItem(cityRegionList,cityList);

    regionItem = disposeRegionItemCallback(regionItem);

    if(cityRegionItem){
      isFirst = false;
      cityRegionItem.regionHeaderList.push(regionItem);
    }else{
      cityRegionItem = Object.assign(baseDataCityListRegionHeaderItem(),{
        cityList:cityList.map(item=>item),// 城市列表 { cityName:"", id:"",},
        regionHeaderList:[regionItem],// 全包(头程) 分区价格信息列表 baseDataRegionHeaderItem()
        isSupportMultiGoodsTypePrice:!!regionItem.isSupportMultiGoodsTypePrice ? 1 : 0,//是否支持多产品分类报价 0>false 1>true
      });
      cityRegionList.push(cityRegionItem);
    }
  })
  return cityRegionList;
}

/**
 * 通过 发货城市列表cityList[]的id组合  匹配对应项
 * @param cityRegionList
 * @param cityList
 * @returns {*}
 */
function findCityRegionItem(cityRegionList=[],cityList=[]) {
  let cityIdsText = cityList.map(item=>item.id).sort().join("_");
  return cityRegionList.find(cityRegionItem=>{
    let cityIdsText2 = cityRegionItem.cityList.map(item=>item.id).sort().join("_");
    return cityIdsText2 === cityIdsText;
  })

}

/**
 * 初始化 单个分区维度item 的数据结构
 * @param regionItem
 * @returns {{dismantlingCityName: string, regionName: string, chargeType: string, type: string, priceDetailList: [], dispatchId: string, extractionAgingFrom: string, isCollectRenewalFee: boolean, supportRenewal: boolean, isOnlySupportRenewal: boolean, agingIsShow: string, regionType: string, currency: string, containerId: string, agingUnit: string, isSupportMultiGoodsTypePrice: number, dismantlingCityId: string, agingType: string, cityList: [], agingTo: string, extractionAgingUnit: string, agingFrom: string, extractionAgingIsShow: string, regionDetailList: [], _id: string, extractionAgingType: string, extractionAgingTo: string} & {cityList: *[]}}
 */
export function initEditDataRegionItem(regionItem={}){
  regionItem.priceDetailList = regionItem.priceDetailList.map(priceDetailItem=>{
    priceDetailItem.volumeWeightRatio = priceDetailItem.goodsTypeList && priceDetailItem.goodsTypeList.length ?
                                        priceDetailItem.goodsTypeList[0].volumeWeightRatio : ''
    priceDetailItem.weightVolumeRatio = priceDetailItem.goodsTypeList && priceDetailItem.goodsTypeList.length ?
                                        priceDetailItem.goodsTypeList[0].weightVolumeRatio : ''
    return Object.assign(baseDataPriceDetailItem(),priceDetailItem);
  });
  return  Object.assign(baseDataRegionHeaderItem(),regionItem,{
    cityList:[],
  })
}

/**
 * 从分区维度列表中 获取默认（第一个）币种
 * @param regionHeaderList
 * @returns {string}
 */
export function getRegionHeaderListDefaultCurrency(regionHeaderList=[]){
  if(!(isArray(regionHeaderList) && regionHeaderList.length)) return "";
  let regionItem = regionHeaderList[0];
  if(!(isObject(regionItem))) return "";
  return regionItem.currency||"";
}

/**
 * 从分区维度列表中 获取默认（第一个）渠道代码
 * @param regionHeaderList
 * @returns {string|*|string}
 */
export function getRegionHeaderListDefaultChannelCode(regionHeaderList=[]){
  if(!isArray(regionHeaderList)) return "";
  let regionItem = regionHeaderList[0];
  if(!isObject(regionItem)) return "";
  if(!isArray(regionItem.priceDetailList)) return "";
  let priceDetailItem = regionItem.priceDetailList[0];
  if(!isObject(priceDetailItem)) return "";
  return priceDetailItem.channelCode||"";
}



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/freightPrice.js